import SocialSignin from './SocialSignin';

export default SocialSignin;
